"use client"

import React from "react"
import { useNavigate } from "react-router-dom"
import { Button } from "./ui/button"

function TermsOfService() {
  const navigate = useNavigate()

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-900 to-black text-white overflow-hidden">
      <nav className="w-full z-50 bg-gray-900/90 backdrop-blur-md py-3 shadow-lg">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center">
            <div className="flex items-center space-x-2">
              <span className="text-2xl font-bold" onClick={() => navigate("/home")}>Rivals <span className="text-emerald-400">Sportsbook</span></span>
            </div>
            <div className="flex items-center space-x-3">
              <Button onClick={()=>{navigate("/signin")}} variant="outline" className="border-gray-700 hover:bg-gray-800 hover:text-white">Log In</Button>
              <Button onClick={()=>{navigate("/signup")}} className="bg-emerald-500 hover:bg-emerald-600 text-white">Sign Up</Button>
            </div>
          </div>
        </div>
      </nav>

      <div className="relative">
        <div className="absolute -top-40 -right-40 w-96 h-96 bg-emerald-500/20 rounded-full blur-3xl pointer-events-none -z-10"></div>
        <div className="absolute top-1/2 -left-40 w-96 h-96 bg-blue-500/20 rounded-full blur-3xl pointer-events-none -z-10"></div>

        <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="max-w-3xl mx-auto">
            <div className="text-center mb-10">
              <h1 className="text-4xl font-bold mb-3">Terms of Service</h1>
              <p className="text-gray-300">Please read these terms carefully before using Rivals Sportsbook.</p>
            </div>

            <div className="bg-gray-800/50 backdrop-blur-sm border border-gray-700 rounded-xl p-8 shadow-xl space-y-8">
              <section>
                <h2 className="text-2xl font-semibold mb-3">1. Acceptance of Terms</h2>
                <p className="text-gray-300">By creating an account or using the platform, you agree to these Terms of Service and any policies referenced herein.</p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-3">2. Eligibility</h2>
                <p className="text-gray-300">You must be at least 18 years old and legally permitted to participate in sports wagering in your jurisdiction.</p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-3">3. Account Responsibilities</h2>
                <ul className="list-disc pl-5 text-gray-300 space-y-2">
                  <li>Maintain accurate account information</li>
                  <li>Safeguard your login credentials</li>
                  <li>Use the platform in compliance with applicable laws</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-3">4. Prohibited Conduct</h2>
                <p className="text-gray-300">You agree not to engage in fraud, abuse, attempts to circumvent limits, or any conduct that harms other users or the platform.</p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-3">5. Deposits, Withdrawals, and Wagering</h2>
                <p className="text-gray-300">All financial transactions are subject to verification. Wagers are final once placed and are governed by posted rules and markets at the time of placement.</p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-3">6. Suspension or Termination</h2>
                <p className="text-gray-300">We may suspend or terminate accounts that violate these terms or applicable laws. Remaining balances will be handled per our policies and legal requirements.</p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-3">7. Disclaimer of Warranties</h2>
                <p className="text-gray-300">The service is provided "as is" without warranties of any kind to the fullest extent permitted by law.</p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-3">8. Limitation of Liability</h2>
                <p className="text-gray-300">To the maximum extent allowed by law, Rivals Sportsbook will not be liable for indirect or consequential damages arising from use of the platform.</p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-3">9. Changes to Terms</h2>
                <p className="text-gray-300">We may update these terms periodically. Continued use after updates constitutes acceptance of the revised terms.</p>
              </section>

              <div className="pt-4">
                <Button onClick={()=>navigate("/")} className="bg-emerald-500 hover:bg-emerald-600 text-white">Back to App</Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TermsOfService


